import React, { Component } from 'react'

class ImageBanner extends Component {

  render() {
    const { image } = this.props

    return (
      <>
        <section className='image-banner' data-color='#FFF'>
          <div className='image-banner__inner'>
            { image && <img src={image.localFile.publicURL} alt={`Whitefox`} /> }
          </div>
        </section>
      </>
    )
  }
}

export default ImageBanner
